// extracted by mini-css-extract-plugin
export default {"topSectionActions":"actionsSection_topSectionActions__Vz+Sv"};